import ProductsCard from "~/components/Admin/Reports/ReportsProducts/ProductsCard"

const ProductsList = ({ data, camp }) => {
  return (
    <div className="py-1">
      {data && data.map((addonData, index) => <ProductsCard key={index} addonData={addonData} camp={camp} />)}
    </div>
  )
}

export default ProductsList
